import { render, staticRenderFns } from "./sportClubSportTypeForm.vue?vue&type=template&id=9e12b808&"
import script from "./sportClubSportTypeForm.vue?vue&type=script&lang=js&"
export * from "./sportClubSportTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports